import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const retailerFundedMarketingAccessControl: DomainAccessControlConfig = [
  {
    permissions: [
      Permission.RetailerFundedMarketingRetailerFundedMarketingViewAccess,
      Permission.RetailerFundedMarketingRetailerFundedMarketingModifyAccess,
    ],
  },
]

export const dynamicCsvBucketAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.useDynamicCsvUploadBucket],
    minICPlatformVersion: ICPlatformVersion.r2024_08_0,
  },
  {
    warehouseFeatureToggles: [FeatureToggle.useDynamicCsvUploadBucketRetailer],
  },
]
